module.exports = __webpack_public_path__ + "static/media/logo_orange.7e1bd552.png";